export default "__VITE_ASSET__Dacmnlvq__"